import * as Sentry from '@sentry/nextjs';
// copied and adjusted from current website to reproduce current behavior
export const openPopupWin = (
  url: string,
  name: string,
  scrollbars: boolean,
  resizeable: boolean,
  width: number,
  height: number
) => {
  if (typeof window === 'undefined') {
    return false;
  }
  const specs = `width=${width},height=${height},left=${(window.screen.width - width) / 2},top=${
    (window.screen.height - height) / 2
  },resizable=${resizeable ? 'yes' : 'no'},scrollbars=${scrollbars ? 'yes' : 'no'},dependent=yes`;
  const popup = window?.open(url, name, specs);
  try {
    popup?.focus();
  } catch (error) {
    Sentry.captureException(new Error(`Could not popup?.focus() - ${error as string}`));
    return false;
  }
  return true;
};
